// test942
(942 && 0);
